import { RootState } from "@base/store";
import Button from "@components/atoms/button";
import { reviewActions } from "@components/features/review/review.slice";
import { GameRatingBodyProps } from "@components/features/review/review.type";
import Rating from "@components/molecules/rating";
import React from "react";
import { ConnectedProps, connect, useSelector } from "react-redux";

import {
  ActionWrapper,
  Container,
  Header,
  IconWrapper,
  ImageWrapper,
  RatingWrapper,
  SubTitle,
  Title,
} from "./userRating.styled";
import { ComponentProps } from "./userRating.type";

import { ReactComponent as SoccerPanna } from "@assets/images/soccer-panna/Junior soccer-pana 1.svg";
import { ReactComponent as Cross } from "@assets/images/status-icons/x-mark.svg";

type ReduxProps = ConnectedProps<typeof connector>;

const UserRating = ({
  handelNext,
  handleBack,
  addRatingForGame,
}: ComponentProps & ReduxProps) => {
  const [value, setValue] = React.useState<number | null>(null);
  const user = useSelector((state: RootState) => state.user.user);
  const selectedGame = useSelector((state: RootState) => state.selectedGame);

  const handleRatingChange = (newValue: number | null) => {
    setValue(newValue);
  };

  // FIXME: will use it later
  // const getPlayerIdByUUID = (uuid: string) => {
  //   for (const side of selectedGame?.sides) {
  //     for (const player of side.players) {
  //       if (player.rsvp.user.id === uuid) {
  //         return player.id;
  //       }
  //     }
  //   }
  // };

  const handleGameRatingSubmit = async () => {
    if (user.uuid && selectedGame?.id) {
      const body: GameRatingBodyProps = {
        rating: value!,
        review_text: "",
        game_id: selectedGame?.id,
      };
      const response = await addRatingForGame(body);
      if (response?.meta?.requestStatus === "fulfilled") {
        handelNext();
      }
    }
  };

  return (
    <Container>
      <Header>
        <IconWrapper>
          <Cross onClick={handleBack} />
        </IconWrapper>
        <Title>Great job!</Title>
        <RatingWrapper>
          <SubTitle>How did you enjoy the game?</SubTitle>
          <Rating
            value={value}
            handleChange={(e, val) => handleRatingChange(val)}
          />
        </RatingWrapper>
      </Header>
      <ImageWrapper>
        <SoccerPanna />
      </ImageWrapper>
      <ActionWrapper>
        <Button
          isDisabled={value ? false : true}
          textColor={"#FFF"}
          text={"Next"}
          type={"button"}
          onClick={handleGameRatingSubmit}
        />
      </ActionWrapper>
    </Container>
  );
};
const mapDispatchToProps = {
  addRatingForGame: reviewActions.gameRating,
};

const connector = connect(undefined, mapDispatchToProps);
const UserRatingRedux = connector(UserRating);

export { UserRatingRedux as UserRating };
